const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

const ProductListModal = require('app/restaurant/analyse/product/ListModal');
const InvoiceCreateModal = require('app/restaurant/analyse/invoice/CreateModal');
const ConfirmModal = require('app/ui/modal/Confirm');
const SynthesisShowModal = require('app/restaurant/analyse/synthesis/ShowModal');
const ExportPDFModal = require('app/restaurant/analyse/export/PDFModal');
const ExportExcelModal = require('app/restaurant/analyse/export/ExcelModal');

class InvoiceBox {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,/***/},
            'analyse': {'id':null,/***/},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickGenerate = this.onClickGenerate.bind(this);
        this.onClickCreateInvoice = this.onClickCreateInvoice.bind(this);
        this.onClickShowSynthesis = this.onClickShowSynthesis.bind(this);
        this.onClickSendToTrame = this.onClickSendToTrame.bind(this);
        this.onClickExportPDF = this.onClickExportPDF.bind(this);
        this.onClickExportExcel = this.onClickExportExcel.bind(this);

        this.build = this.build.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.analyse = this.settings.analyse;
        if(!this.analyse.id){
            window.notify("Missing analyse object in InvoiceBox","danger");
        }
        this.restaurant = this.settings.restaurant;
        if(!this.restaurant.id){
            window.notify("Missing restaurant object in InvoiceBox","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.loadData();
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$container
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildAnalyseQuery(),
            this.buildProductPriceQuery(),
            this.buildProductAnalysisQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.build(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildAnalyseQuery(){
        var self = this;

        let parameters = {
            'id': this.analyse.id,
        };

        let fields = [
            'id',
            'analysePeriodBegin',
            'analysePeriodEnd',
            'total',
            'compiledData { supplier { name } total orders { id date total  } }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProspectAnalyse',
            'parameters': parameters,
            'fields': fields,
        });

        return query;
    }


    buildProductPriceQuery(){
        var self = this;

        let parameters = {
            'filter': {
                'restaurant': this.restaurant.id,
                'used': false,
            }
        };

        let fields = [];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'analysisRestaurantProductPrices',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildProductAnalysisQuery(){
        var self = this;

        let parameters = {
            'filter': {
                'restaurant': this.restaurant.id,
                'used': false,
                'trimester': 0,
                'notInBookmarkOf': this.restaurant.id,
            }
        };

        let fields = [];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'analysisRestaurantProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    build(data){
        this.analyse = data.restaurantProspectAnalyse;

        let analysisRestaurantProductPrices = data.analysisRestaurantProductPrices;
        let analysisRestaurantProducts = data.analysisRestaurantProducts;
        let hasAnalysePriceSet = false;
        let hasAnalyseProductNotInBookmark = false;
        
        if(analysisRestaurantProductPrices.totalCount > 0){
            hasAnalysePriceSet = true;
        }

        if(analysisRestaurantProducts.totalCount > 0){
            hasAnalyseProductNotInBookmark = true;
        }

        if(hasAnalysePriceSet || hasAnalyseProductNotInBookmark){
            this.hasProductPricesToSend = true;
        }else{
            this.hasProductPricesToSend = false;
        }

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-8')
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append(this.buildInvoiceListHeader())
                    .append(this.buildInvoiceListBody())

                )
            )
            .append(
                $('<div/>')
                .addClass('col-4 ps-2')
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append(this.buildActionListHeader())
                    .append(this.buildActionListBody())
                )
            )
        );


        this.$container
        .html('')
        .append($content);

    }

    buildActionListHeader(){
        let $content = $('<h3/>')
        .append(window.translate('app.restaurant.show.tabs.analyse.actions.title'));

        return $content;
    }
    buildActionListBody(){
        let $content = $('<div/>');

        this.$btnGenerate = $('<button/>')
        .attr("type",'button')
        .addClass("btn btn-primary")
        .append(
            $('<i/>')
            .addClass("fas fa-spin fa-spinner")
            .hide()
        )
        .append(' ')
        .append(window.translate('app.restaurant.show.tabs.analyse.actions.generate.label'))
        .on('click',this.onClickGenerate);


        this.$btnShowSynthesis = $('<button/>')
        .attr("type",'button')
        .addClass("btn btn-primary")
        .append(
            $('<i/>')
            .addClass("fas fa-euro-sign")
        )
        .append(' ')
        .append(window.translate('app.restaurant.show.tabs.analyse.actions.show.label'))
        .on('click',this.onClickShowSynthesis);

        this.$btnExportPDF = $('<button/>')
        .attr("type",'button')
        .addClass("btn btn-danger btn-export-pdf")
        .append(
            $('<i/>')
            .addClass("fas fa-file-pdf")
        )
        .append(' ')
        .append(window.translate('app.restaurant.show.tabs.analyse.actions.exportPDF.label'))
        .on('click',this.onClickExportPDF);

        this.$btnExportExcel = $('<button/>')
        .attr("type",'button')
        .addClass("btn btn-success btn-export-excel")
        .append(
            $('<i/>')
            .addClass("fas fa-file-excel")
        )
        .append(' ')
        .append(window.translate('app.restaurant.show.tabs.analyse.actions.exportExcel.label'))
        .on('click',this.onClickExportExcel);




        this.$btnSendToTrame = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-success btn-send-to-trame')
        .append(window.translate('app.restaurant.show.tabs.analyse.actions.sendToTrame.label'))
        .on('click',this.onClickSendToTrame);
            

        let $sendToTrameContainer = $('<div/>')
        .addClass('send-to-trame')
        .append(window.translate('app.restaurant.show.tabs.analyse.actions.sendToTrame.description'))
        .append(' : ')
        .append(this.$btnSendToTrame);

        if(!this.hasProductPricesToSend){
            $sendToTrameContainer.hide();
        }


        $content
        .append(
            $('<div/>')
            .addClass('mb-2')
            .append(this.$btnGenerate)
        )        
        .append(
            $('<div/>')
            .addClass('mb-2')
            .append(this.$btnShowSynthesis)
        )
        .append(
            $('<div/>')
            .addClass('mb-2')
            .append(this.$btnExportPDF)
        )
        .append(
            $('<div/>')
            .addClass('mb-2')
            .append(this.$btnExportExcel)
        )
        .append(
            $sendToTrameContainer
        )


        return $content;
    }

    buildInvoiceListHeader(){
        let $content = $("<div/>")
        .addClass("restaurant-analyse-invoice-box-header");

        let $title = $('<h3>')
        .addClass('')
        .append(window.translate('app.restaurant.show.tabs.analyse.invoice.label'));

        this.$btnCreateInvoice = $('<button/>')
        .addClass('btn btn-success')
        .attr('title',window.translate('app.restaurant.show.tabs.analyse.invoice.create.label'))
        .append(
            $('<i/>')
            .addClass('fas fa-plus-circle')
        )
        .on('click',this.onClickCreateInvoice)

        $content
        .append(
            $('<div/>')
            .addClass('float-end')
            .append(this.$btnCreateInvoice)
        )
        .append($title);


        return $content;
    }



    buildInvoiceListBody(){
        var self = this;
        let $content = $("<div/>")
        .addClass("restaurant-analyse-invoice-box-list");

        this.$btnShowAll = $('<button/>')
        .addClass('btn btn-success btn-show-all')
        .append(
            $('<i/>')
            .addClass("far fa-search")
        )
        .append(' ')
        .append(window.translate('app.restaurant.show.tabs.analyse.invoice.show.label'))
        .on('click',function(event){
            self.onClickShowAllProductList();
        });


        this.$btnClear = $('<button/>')
        .addClass('btn btn-danger btn-clear')
        .append(
            $('<i/>')
            .addClass("fas fa-trash")
        )
        .append(' ')
        .append(window.translate('app.restaurant.show.tabs.analyse.invoice.clear.label'))
        .on('click',function(event){
            self.onClickClear(event);
        });

        let $actions = $('<div/>')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-6')
            .append( this.$btnShowAll )
        )
        .append(
            $('<div/>')
            .addClass('col-6 d-flex justify-content-end')
            .append( this.$btnClear )
        )



        $content
        .append(this.buildTable())
        .append($actions);



        return $content;
    }

    buildTable(){
        var self = this;

        let $table = $('<table/>')
        .addClass('table table-striped')
        .append(
            $('<thead>')
            .append(
                $('<tr>')
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.invoice.supplier.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.invoice.entered.label'))
                )
            )
        );

        let $tbody = $("<tbody/>")
        .appendTo($table);

        for(var i in this.analyse.compiledData){
            let currentData = this.analyse.compiledData[i];

            let supplier = currentData.supplier;
            let totalSupplier = currentData.total;
            let orders = currentData.orders;

            let $orderContent = $('<div/>');

            for(var o in orders){
                let order = orders[o];

                let date = moment(order.date);
                let totalOrder = order.total;

                let $btnOrder = $('<button/>')
                .attr('type','button')
                .addClass('btn btn-info btn-analyse-order')
                .attr('data-order-index',o)
                .attr('data-supplier-index',i)
                .append(
                    $('<i/>')
                    .addClass('far fa-pen')
                )
                .append(' ')
                .append(window.formatDate(date,window.translate('momentDateFormat.fullDay')))
                .append(' - ')
                .append(window.formatFloat(totalOrder) + ' &euro;')
                .on('click',function(event){
                    let $btn = $(this);
                    self.onClickShowInvoiceProductList($btn);
                })

                $orderContent
                .append(
                    $('<div/>')
                    .addClass('mb-1')
                    .append($btnOrder)
                );
            }

            $orderContent.append(
                $('<div/>')
                .addClass('text-muted')
                .append(window.translate('total'))
                .append(' : ')
                .append(window.formatFloat(totalSupplier) + ' &euro;')
            );

            let labelSupplier = supplier.name + ' (' + orders.length + ' ' + window.translate('invoice') + (orders.length > 1 ? 's' : '') + ')';
            let $row = $('<tr>')
            .append(
                $('<td/>')
                .append(labelSupplier)
            )
            .append(
                $('<td/>')
                .append($orderContent)
            )
            .appendTo($tbody);
        }

        $tbody.append(
            $('<tr/>')
            .append(
                $('<td/>')
                .attr('colspan',2)
                .append(
                    $('<div/>')
                    .addClass('text-muted')
                    .append(window.translate('generalTotal'))
                    .append(' : ')
                    .append(window.formatFloat(this.analyse.total) + ' &euro;')
                )
            )
        )

        return $table;
    }

    onClickShowInvoiceProductList($btn){
        var self = this;

        let supplierIndex = $btn.data('supplier-index');
        let orderIndex = $btn.data('order-index');

        let currentData = this.analyse.compiledData[supplierIndex]
        let supplier = currentData['supplier'];
        let invoice = currentData['orders'][orderIndex];
        let date = moment(invoice.date);

        let title = window.translate(
            'app.restaurant.show.tabs.analyse.invoice.modal.invoice.title',
            {
                '%supplierName%':supplier.name,
                '%date%':window.formatDate(date,window.translate('momentDateFormat.fullDay'))
            }
        );

        let modal = new ProductListModal({
            'title': title,
            'restaurant': this.restaurant,
            'analyse': this.analyse,
            'supplierIndex' : supplierIndex,
            'orderIndex' : orderIndex,
            'onNoData': function(){
                self.refresh();
                modal.close();
            },
            'onClose': function(event){
                self.refresh();
            }
        });
    }

    onClickShowAllProductList(){
        var self = this;

        let title = window.translate('app.restaurant.show.tabs.analyse.invoice.modal.all.title');
        let modal = new ProductListModal({
            'title': title,
            'restaurant': this.restaurant,
            'analyse': this.analyse,
            'productAssociations': this.analyse.productAssociations,
            'onClose': function(event){
                self.refresh();
            }
        });
    }

    onClickClear(event){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.restaurant.show.tabs.analyse.invoice.clear.confirm'))
        )
        .append(
            $('<div/>')
            .addClass('text-muted')
            .append(window.translate('app.restaurant.show.tabs.analyse.invoice.clear.confirmWarning'))
        )

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedClear(modal)
            },
            'onCancel': function(event,modal){
                modal.show();
            }
        })
        confirmModal.show();
    }

    onClickCreateInvoice(event){
        event.preventDefault();
        event.stopPropagation();


        let title = window.translate('app.restaurant.show.tabs.analyse.invoice.create.title');
        let modal = new InvoiceCreateModal({
            'title': title,
            'analyse': this.analyse,
            'onSuccess': function(event){
                self.refresh();
            }
        });

    }

    proceedClear(confirmModal){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'analyse': {
                'value': this.analyse.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ClearRestaurantProspectAnalyseProductAssociations",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.onClearSucceed(data);
            },
            'error': function(message, xhr){
                self.onClearFailed(message,xhr);
                confirmModal.dispose();
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onClearSucceed(data){
        window.notify(data.message,"success");
        this.refresh();
    }

    onClearFailed(message,xhr){
        window.notify(message,"error");
    }

    onClickShowSynthesis(event){
        var self = this;
        let modal = new SynthesisShowModal({
            'restaurant': this.restaurant,
            'onNewRestofutePrice': function(){
                self.refresh();
            }
        });
    }

    onClickGenerate(event){
        var self = this;

        let $btn = this.$btnGenerate;

        let oldAdminGenerateUrl = window.App.get('oldAdminBaseUrl') + '/update_analyse_customers/scripts&id=' + this.restaurant.id;

        $('i',$btn)
        .show();
        $btn.attr('disabled','disabled');

        $.ajax({
            'url': oldAdminGenerateUrl,
            'method': 'GET'
        })
        .done(function(xhr){
            
            if(xhr == 'ok'){
                window.notify(window.translate('app.restaurant.show.tabs.analyse.actions.generate.success'),'success');
            }else{
                window.notify(window.translate('app.restaurant.show.tabs.analyse.actions.generate.error'),'error');
            }
        })
        .fail(function(){
            window.notify(window.translate('app.restaurant.show.tabs.analyse.actions.generate.error'),'error');
        })
        .always(function(){
            $('i',$btn)
            .hide();
            $btn.removeAttr('disabled');
        });

        /*
        @todo one day migrate this process to already existing but not implemented Mutation CompileAnalysisRestaurant
        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "CompileAnalysisRestaurant",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
                $('i',$btn)
                .show();

                $btn.attr('disabled','disabled');
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                $('i',$btn)
                .hide();
                $btn.removeAttr('disabled');
            }
        });
        mutation.execute();
        */
    }

    onClickSendToTrame(event){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SendAnalysePriceToRestaurantProductPriceUpdate",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                self.refresh();
            },
            'error': function(message, xhr){
                window.notify(message,"danger");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }


    onClickExportExcel(event){
        let modal = new ExportExcelModal({
            'restaurant': this.restaurant,
        });
    }

    onClickExportPDF(event){
        let modal = new ExportPDFModal({
            'restaurant': this.restaurant,
        });
    }
}

module.exports = InvoiceBox;

